import { GroupType } from "tnbimbase";
import { Command, ModelBase, TnEngineExtraContext } from "pytha";
import { Group } from "@/commons/interface/speccommon/group";



export class StationGroupCommand extends Command {

    entities: ModelBase[];
    groupUuid: string;
    hasEngine: boolean;
    name: string;
    extraContext: TnEngineExtraContext;

    constructor(entities: ModelBase[], groupUuid: string, hasEngine: boolean, name?: string) {
        super();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = this.extraContext.getCurrentViewEditor();
        this.groupUuid = groupUuid;
        this.hasEngine = hasEngine;
        if (name) this.name = name;
        let arr: ModelBase[] = entities;
        for (let entity of arr) {
            if (!entity?.group) {
                entity.group = {};
            }
            let oldArr = entity.group[GroupType.GROUP] || [];
            let newArr = Array.from(new Set([...oldArr, groupUuid]))
            entity.group[GroupType.GROUP] = newArr;
        }
        this.entities = arr;
    }

    execute = () => {
        this.editor.addObjects(this.entities, false);
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.extraContext.apiContext.createPrimitiveMulti(this.entities.map((entity: ModelBase) => {
            if (entity.toJson) {
                return entity.toJson();
            }
            return null
        }));
        let group: Group = {
            uuid: this.groupUuid,
            name: this.name,
        }
        this.extraContext.apiContext.addGroup(group, this.groupUuid, this.hasEngine).then(res => {
            if (res.status === 200) {
                this.extraContext.listeners.signals.onGroupChanged.dispatch();
            }
        })
    }

    undo(): void {
        for (let entity of this.entities) {
            let newArr = (entity.group[GroupType.GROUP] || [])?.filter(g => g !== this.groupUuid);
            entity.group[GroupType.GROUP] = newArr;
        }
        this.editor.addObjects(this.entities, false);
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.extraContext.apiContext.createPrimitiveMulti(this.entities.map((entity: ModelBase) => {
            if (entity.toJson) {
                return entity.toJson();
            }
            return null
        }));
        this.extraContext.apiContext.deleteGroup(this.groupUuid).then(res => {
            if (res.status === 200) {
                this.extraContext.listeners.signals.onGroupChanged.dispatch();
            }
        })
    }

}